import React from 'react';
import { ReactComponent as RedIndicator } from '../../../assets/logos/redIndicator.svg';
import { ReactComponent as GreenIndicator } from '../../../assets/logos/greenIndicator.svg';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PEARL_CONNECT_ACCENT } from 'vendor/styles/pearlConnectFormUiOverrides';

const TealSuccessIndicator = styled(GreenIndicator)`
    g path:nth-of-type(1) {
        fill: ${PEARL_CONNECT_ACCENT};
    }
`;

const PasswordValidations = styled.div`
    margin-top: 8px;
    .passwordInstructionStyle {
        display: flex;
        gap: 8px;
        margin-top: 8px;
    }
    .passwordTextStyle {
        color: var(--text-icon-secondary, #464646);
        font-family: 'Objektiv Mk2';
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px;
        margin: 0px;
        padding-top: 0;
    }
    .passwordStrength-weak,
    .passwordStrength-medium {
        position: relative;
        top: 1px;
        left: -4px;
        color: #920505;
        font-family: 'Objektiv Mk2';
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
    }
    .passwordStrength-strong {
        position: relative;
        top: 1px;
        left: -4px;
        color: ${PEARL_CONNECT_ACCENT};
        font-family: 'Objektiv Mk2';
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
    }
    .indicatorStyle {
        margin: 2px;
        height: 16px;
    }
`;

const PasswordValidation = ({ passwordStrength = 'weak', validationStatus = {} }) => {
    const { t } = useTranslation();
    const tInstr = (suffix) => t(`Forms.Validation.PasswordInstructions.${suffix}`);

    const rows = [
        {
            key: 'Subtext1',
            isValid: passwordStrength !== 'weak',
            strengthLabel: passwordStrength,
        },
        { key: 'Subtext2', isValid: validationStatus.noEmailOrName },
        { key: 'Subtext3', isValid: validationStatus.length },
        { key: 'Subtext4', isValid: validationStatus.numberOrSymbol },
        { key: 'Subtext5', isValid: validationStatus.uppercaseLowercase },
    ];

    return (
        <PasswordValidations>
            {rows.map(({ key, isValid, strengthLabel }) => (
                <div key={key} className="passwordInstructionStyle">
                    {isValid ? (
                        <TealSuccessIndicator
                            data-testid="green-indicator"
                            className="indicatorStyle"
                        />
                    ) : (
                        <RedIndicator data-testid="red-indicator" className="indicatorStyle" />
                    )}
                    <p className="passwordTextStyle">{tInstr(key)}</p>
                    {strengthLabel != null && (
                        <span className={`passwordStrength-${strengthLabel}`}>{strengthLabel}</span>
                    )}
                </div>
            ))}
        </PasswordValidations>
    );
};

PasswordValidation.propTypes = {
    passwordStrength: PropTypes.string,
    validationStatus: PropTypes.shape({
        noEmailOrName: PropTypes.bool,
        length: PropTypes.bool,
        numberOrSymbol: PropTypes.bool,
        uppercaseLowercase: PropTypes.bool,
    }),
};

export default PasswordValidation;
